/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  interview_submit_request_create_candidate_action,
  get_jobs_linked_with_assigned_assessment_kit_candidate_action,
} from "../../../redux/_actions/candidate";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

function useInterviewSubmitReview() {
  const url = new URL(window.location.href);
  const interviewKitId = url.searchParams.get("interviewKit");
  const jobId = url.searchParams.get("appliedJob");

  const [assignedInterviewKit, setAssignedInterviewKit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [jobsLinkedWithAssignedKit, setJobsLinkedWithAssignedKit] = useState(
    []
  );
  //pagination
  const [nextPage, setNextPage] = useState(null);
  const [pageNum, setPageNum] = useState(1);

  const dispatch = useDispatch();

  const { jobsLinkedWithAssignedKitData } = useSelector(
    (state) =>
      state.get_jobs_linked_with_assigned_assessment_kit_candidate_action
  );

  useEffect(() => {
    if (interviewKitId && jobId) {
      // callSubmitApi(interviewKitId, jobId);
      setLoading(true);
      callApi(interviewKitId);
      setAssignedInterviewKit(interviewKitId);
    } else {
      showWarningMessage(
        "Unable to find the assessment kit you are looking for."
      );
    }
  }, []);

  useEffect(() => {
    if (nextPage) {
      callApi(assignedInterviewKit);
    }
  }, [pageNum]);

  useEffect(() => {
    if (jobsLinkedWithAssignedKitData?.data) {
      let data = jobsLinkedWithAssignedKitData.data?.results;
      let results = jobsLinkedWithAssignedKit;
      data.forEach((newItem) => {
        if (!results.find((item) => item.id === newItem.id)) {
          results.push(newItem);
        }
      });
      setJobsLinkedWithAssignedKit(results);
      setPageNum(1);
      setNextPage(jobsLinkedWithAssignedKitData?.data.next);
    }
  }, [jobsLinkedWithAssignedKitData]);

  const callApi = async (interviewKit) => {
    setLoading(true)
    await dispatch(
      get_jobs_linked_with_assigned_assessment_kit_candidate_action(
        interviewKit,
        pageNum
      )
    );
    setLoading(false);
  };

  const onSubmitClick = async (id) => {
    await dispatch(
      interview_submit_request_create_candidate_action(
        id,
        assignedInterviewKit,
        {
          interview_submitted: "true",
        }
      )
    );
    callApi(assignedInterviewKit);
  };

  return {
    loading,
    jobsLinkedWithAssignedKit,
    onSubmitClick,
  };
}

export default useInterviewSubmitReview; 
